import React, { useEffect, useState } from 'react'
import authQueries from '../../queries/authQueries'
import Empty from '../../components/Empty'
import { snackbarToast } from '../../components/SnackbarToast'
import Loader from '../../components/Loader'
import StatusType from '../../components/StatusType'
import { useApi } from '../../utils/ApiProvider'
import lunchQueries from '../../queries/lunchQueries'
import { Button, Checkbox } from '@nextui-org/react'
import { IconTrash, IconX } from '@tabler/icons-react'
import statusQueries from '../../queries/statusQueries'
import moment from 'moment/moment'
import { BASE_URL } from '../../apis/api'

const LunchScreen = () => {

    const today = moment().format('YYYY-MM-DD')
    const [result, setResult] = useState([])
    const [date, setDate] = useState(today)
    const [isLunch, setIsLunch] = useState(true)

    const { apiData, setApiDataAndNotify } = useApi()

    const getData = lunchQueries.useTodayLunchUsers(
        (res)=>{
            if(res?.success){
                setResult(res?.data)
            }else{
                setResult([])
            }
        }
    )

    const exportData = lunchQueries.useTodayLunchUsers(
        (res)=>{
            if(res?.success){
                window.open(BASE_URL + res?.url)
                snackbarToast(res?.message, 'success')
            }else{
                snackbarToast(res?.message, 'error')
            }
        }
    )

    useEffect(() => {
        getData.mutateAsync({date, isLunch})
    }, [apiData, date, isLunch]);

    const workStatusCreate = statusQueries.useTodayWorkStatusCreate(
        (res) => {
          if(res?.success) {
            setApiDataAndNotify(new Date());
          }
        }
    );

    const handleClear = (user) => {
        workStatusCreate.mutateAsync({
            lunch_status: "NO",
            user_id: user?.id,
            date
        });
    }

    const handleExport = async() => {
        const data = await exportData.mutateAsync({date, isExport: true, isLunch})
    }

  return (

    <div className='card-shadow m-4 max-[768px]:m-2 bg-white rounded-[10px] pb-10'>

        <div className='flex justify-between max-[934px]:flex-col items-center p-6 gap-y-3'>
            <div>
                <p className='text-[13px] text-[#6D6B77] font-medium'>Showing {result?.length} entries</p>
            </div>
            <div className='flex items-center gap-3'>
                <input
                type='date'
                value={date}
                onChange={(e)=>{setDate(e.target.value)}}
                className='w-[300px] max-[799px]:w-full h-[40px] border rounded-[7px] pl-3 pr-3 mt-[1px] text-[13px]'
                />
                <Button onClick={handleExport} className='bg-primary text-white font-bold'>
                    Export
                </Button>
            </div>
        </div>

        {
            getData?.isLoading ?
            <div className="w-full flex items-center justify-center py-40">
                <Loader />
            </div>:
            <div className='px-6 overflow-x-auto'>
                {
                    result?.length > 0 ?
                        <table className='table w-full'>
                            <thead>
                                <tr className='table-row'>
                                    <th>Sl No.</th>
                                    <th>Emp Code</th>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>Department</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {result?.map((row, index) => {
                                    const user = row.user
                                    return(
                                        <tr key={index} className='table-row'>
                                            <td>{index + 1}</td>
                                            <td className='py-3'>{user?.emp_id}</td>
                                            <td>{user?.name}</td>
                                            <td>{user?.email}</td>
                                            <td>{user?.group?.name}</td>
                                            <td>
                                                <div className='flex gap-2 justify-end'>
                                                    <Button color='danger' isIconOnly onClick={()=> handleClear(user)}>
                                                        <IconX size={20} />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                )}
                            </tbody>
                        </table>:
                    <Empty />
                }
            </div>
        }

    </div>
  )
}

export default LunchScreen